<template>
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_27_267)">
      <path
        d="M10.4913 0.722412H1.06153C0.503114 0.722412 0.0488281 1.1767 0.0488281 1.73511V7.52619C0.0488281 7.71174 0.199256 7.86217 0.384805 7.86217H1.73825C1.9238 7.86217 2.07423 7.71174 2.07423 7.52619V7.46672H4.23111C4.21926 7.54417 4.2131 7.62347 4.2131 7.70419C4.2131 8.56619 4.9144 9.26749 5.7764 9.26749C6.63841 9.26749 7.3397 8.56619 7.3397 7.70419C7.3397 7.62347 7.33354 7.54417 7.3217 7.46672H9.47858V7.52619C9.47858 7.71174 9.629 7.86217 9.81455 7.86217H11.168C11.3536 7.86217 11.504 7.71174 11.504 7.52619V1.73511C11.504 1.1767 11.0497 0.722412 10.4913 0.722412ZM2.07423 6.79477V6.28014H3.47171V6.76807C3.47171 6.7771 3.47236 6.78594 3.47306 6.79477H2.07423ZM3.47169 3.89029V4.41327H2.07423V3.89029H3.47169ZM2.07423 3.21834V2.74779H3.47171V3.21834H3.47169H2.07423ZM3.47171 5.08521V5.60819H2.07423V5.08521H3.47171ZM4.50605 6.79477H4.1423C4.143 6.78592 4.14365 6.77707 4.14365 6.76807V6.28014H5.13269C4.88134 6.39422 4.66542 6.57278 4.50605 6.79477ZM5.44043 3.89029V4.41327H4.14365V3.89029H5.44043ZM4.14365 3.21832V2.74779H5.44043V3.21832H4.14365ZM5.44043 5.08521V5.60819H4.14365V5.08521H5.44043ZM5.7764 8.59554C5.28491 8.59554 4.88506 8.19568 4.88506 7.70419C4.88506 7.2127 5.28491 6.81284 5.7764 6.81284C6.26789 6.81284 6.66775 7.2127 6.66775 7.70419C6.66775 8.19568 6.26789 8.59554 5.7764 8.59554ZM7.40916 3.89029V4.41327H6.11238V3.89029H7.40916ZM6.11238 3.21832V2.74779H7.40916V3.21832H6.11238ZM7.40916 5.08521V5.60819H6.11238V5.08521H7.40916ZM7.04675 6.79477C6.88737 6.57278 6.67147 6.39422 6.42011 6.28014H7.40916V6.76807C7.40916 6.7771 7.40981 6.78594 7.41051 6.79477H7.04675ZM9.4786 6.79477H8.07977C8.08044 6.78592 8.08111 6.77707 8.08111 6.76807V6.28014H9.4786V6.79477ZM8.08109 3.21832V2.74779H9.47858V3.21832H8.08109ZM9.4786 5.60819H8.08111V5.08521H9.4786V5.60819ZM9.4786 4.41327H8.08111V3.89029H9.4786V4.41327ZM10.832 7.19021H10.1505V2.41182C10.1505 2.22627 10.0001 2.07584 9.81455 2.07584H1.73825C1.5527 2.07584 1.40228 2.22627 1.40228 2.41182V7.19019H0.720782V1.73511C0.720782 1.54724 0.873629 1.39437 1.06153 1.39437H10.4913C10.6792 1.39437 10.832 1.54724 10.832 1.73511V7.19021Z"
        fill="white"
      />
      <path
        d="M6.85453 9.37292C6.66898 9.37292 6.51855 9.52335 6.51855 9.7089V10.7307C6.51855 10.9163 6.66898 11.0667 6.85453 11.0667C7.04008 11.0667 7.19051 10.9163 7.19051 10.7307V9.7089C7.19051 9.52335 7.04008 9.37292 6.85453 9.37292Z"
        fill="white"
      />
      <path
        d="M5.77641 9.8844C5.59086 9.8844 5.44043 10.0348 5.44043 10.2204V11.855C5.44043 12.0405 5.59086 12.1909 5.77641 12.1909C5.96196 12.1909 6.11238 12.0405 6.11238 11.855V10.2204C6.11238 10.0348 5.96196 9.8844 5.77641 9.8844Z"
        fill="white"
      />
      <path
        d="M4.69828 9.37292C4.51273 9.37292 4.3623 9.52335 4.3623 9.7089V10.7307C4.3623 10.9163 4.51273 11.0667 4.69828 11.0667C4.88383 11.0667 5.03426 10.9163 5.03426 10.7307V9.7089C5.03426 9.52335 4.88385 9.37292 4.69828 9.37292Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_27_267">
        <rect
          width="11.468"
          height="11.468"
          fill="white"
          transform="translate(0.0429688 0.722534)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {};
</script>
